var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71572 6.71573 0 15 0H265C273.284 0 280 6.71573 280 15V280H0V15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 82.625C116.801 82.625 96.6562 102.77 96.6562 127.469C96.6562 142.809 104.464 156.422 116.275 164.505C93.353 174.264 77.4375 197.037 77.4375 223.562H90.25C90.25 194.96 112.897 172.312 141.5 172.312C170.103 172.312 192.75 194.96 192.75 223.562H205.562C205.562 197.037 189.647 174.264 166.725 164.505C178.536 156.422 186.344 142.809 186.344 127.469C186.344 102.77 166.199 82.625 141.5 82.625ZM141.5 95.4375C159.267 95.4375 173.531 109.701 173.531 127.469C173.531 145.236 159.267 159.5 141.5 159.5C123.733 159.5 109.469 145.236 109.469 127.469C109.469 109.701 123.733 95.4375 141.5 95.4375Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultRound);
export default __webpack_public_path__ + "static/media/defaultRound.60d0940ca9bec6971997181847862aa5.svg";
export { ForwardRef as ReactComponent };